import "./section-heading-component-styles.scss";

const SectionHeadingComponent = ({ text, additional }) => {
	return (
		<div className="heading-box">
			<h2 className="section-heading">{text}<br/>{additional}</h2>
		</div>
	);
};

export default SectionHeadingComponent;
